module.exports = __webpack_public_path__ + "img/card_login.b4a31663.png";